import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {
    ServiceTypeEnum,
    RootMenuEnum,
    RiderVehicleTypeEnum,
    MenuPermissionActionEnum, MenuPermissionConfig
} from 'app/models';
import { AppDataService, ConfigService } from 'app/services';
import { AppComponent } from 'app/app.component';
import { Subscription } from 'rxjs';

export enum OpsTowerMenuEnum {
    LiveMap = 1,
    Operators = 2,
    OperatorsVehicles = 3,
    OperatorsTODAs = 4,
    Drivers = 5,
    DriversDisciplinary = 6,
    Users = 7,
    Transactions = 8,
    Reports = 9,
    ReportsDrivers = 10,
    ReportsCustomers = 11,
    ReportsOperators = 12,
    Promo = 13,
    Dashboard = 14,
    ActiveOrder = 15,
    BookingRide = 16,
    BookingSend = 17,
    BookingDelivery = 18,
    BookingRent = 19,
    BookingPetTaxi = 20,
    BookingTransfers = 21,
    HeatMap = 22,
    ReportsDailyStatistics = 23,
    BookingMoto = 24,
    BookingCars = 25,
    BookingAdmin = 26,
    DriverPerformance = 27,
    QuestReport = 28,
    ZonesMap = 29,
    Xpass = 30,
    BookingTaxi = 31,
	TaxiDriverPerformance = 32,
	Tour = 33,
	ExperienceListings = 34,
	/** Ops Tower → Bookings → ConneX → Route Configuration */
	ConnexRouteConfiguration = 35,
	/** Ops Tower → Bookings → ConneX → Bookings */
	ConnexBookings = 36
}

@Component({
    selector: 'ops-tower-root',
    templateUrl: './ops-tower-root.component.html',
    styleUrls: ['./ops-tower-root.component.scss',
        '../../../../styles/menu-sidebar.scss'
    ],
})
export class OpsTowerRootComponent implements OnInit, OnDestroy {
    @Input() serviceTypes: ServiceTypeEnum[] = this.appData.getServiceTypesCurrentLocationType();
    public serviceTypeId: ServiceTypeEnum = (!this.appData.isBoracayLocation && !this.appData.isDumagueteLocation) ? ServiceTypeEnum.Ride : ServiceTypeEnum.None;

    public vehicleType!: RiderVehicleTypeEnum;
    public vehicleTypes!: RiderVehicleTypeEnum[];

    public selectGeoZone: any;
    constructor(public appData: AppDataService,
                public app: AppComponent,
                public configService: ConfigService) { }

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;
    public menuPermissionActive!: string;

    public activeRootMenu: RootMenuEnum | null = null;

    public menuEnum = OpsTowerMenuEnum;
    public activeMenu: OpsTowerMenuEnum = OpsTowerMenuEnum.Dashboard;

    clientLocationTypeSubscription: Subscription | undefined;

    ngOnInit(): void {
        this.activeRootMenu = this.appData.activeRootMenu;

        this.clientLocationTypeSubscription = this.appData.clientLocationType$.subscribe(locationType => {
            this.serviceTypes = this.appData.getServiceTypesCurrentLocationType();
        });
    }

    ngOnDestroy() {
        if (this.clientLocationTypeSubscription) {
            this.clientLocationTypeSubscription.unsubscribe();
        }
    }

    public clickMenu(menuPermissionActive: string, menu: OpsTowerMenuEnum) {
        this.menuPermissionActive = menuPermissionActive;

        this.vehicleType = RiderVehicleTypeEnum.None;
        switch (menu) {
            case OpsTowerMenuEnum.BookingTaxi:
                this.serviceTypeId = ServiceTypeEnum.Taxi;
                break;
            case OpsTowerMenuEnum.BookingRide:
                this.serviceTypeId = ServiceTypeEnum.Ride;
                break;
            case OpsTowerMenuEnum.BookingSend:
                this.serviceTypeId = ServiceTypeEnum.Delivery;
                break;
            case OpsTowerMenuEnum.Xpass:
                this.serviceTypeId = ServiceTypeEnum.Transfer;
                break;
            case OpsTowerMenuEnum.BookingDelivery:
                this.serviceTypeId = ServiceTypeEnum.Grocery;
                break;
            case OpsTowerMenuEnum.BookingRent:
                this.serviceTypeId = ServiceTypeEnum.Ride;
                break;
            case OpsTowerMenuEnum.BookingPetTaxi:
                this.serviceTypeId = ServiceTypeEnum.Ride;
                this.vehicleType = RiderVehicleTypeEnum.PetTaxi;
                break;
            case OpsTowerMenuEnum.BookingTransfers:
                this.serviceTypeId = ServiceTypeEnum.Transfer;
                break;
            case OpsTowerMenuEnum.BookingMoto:
                this.serviceTypeId = ServiceTypeEnum.Ride;
                this.vehicleTypes = [RiderVehicleTypeEnum.Moto];
                break;
            case OpsTowerMenuEnum.BookingCars:
                this.serviceTypeId = ServiceTypeEnum.Ride;
                this.vehicleTypes = [RiderVehicleTypeEnum.Sedan, RiderVehicleTypeEnum.SUV];
                break;
            case OpsTowerMenuEnum.BookingAdmin:
                this.serviceTypeId = ServiceTypeEnum.Ride;
                this.vehicleTypes = [RiderVehicleTypeEnum.Moto, RiderVehicleTypeEnum.Sedan, RiderVehicleTypeEnum.SUV];
                break;
            case OpsTowerMenuEnum.ConnexRouteConfiguration:
                break;
            default:
                break;
        }
        this.activeMenu = menu;
    }

    public getMenuValue() {
        switch (this.activeMenu) {
            case OpsTowerMenuEnum.ReportsDrivers: return 'Drivers';
            case OpsTowerMenuEnum.ReportsCustomers: return 'Customers';
            case OpsTowerMenuEnum.ReportsOperators: return 'Operators';
            case OpsTowerMenuEnum.ReportsDailyStatistics: return 'Daily Statistics';

            case OpsTowerMenuEnum.BookingRide: return 'Ride';
            case OpsTowerMenuEnum.BookingTaxi: return 'Taxi Ride';
            case OpsTowerMenuEnum.BookingSend: return 'Send';
            case OpsTowerMenuEnum.Xpass: return 'Xpass';
			case OpsTowerMenuEnum.Tour: return 'Tour';
			case OpsTowerMenuEnum.ExperienceListings: return 'Experience Listings';
            case OpsTowerMenuEnum.BookingDelivery: return 'Delivery';
            case OpsTowerMenuEnum.BookingRent: return 'Rent';
            case OpsTowerMenuEnum.BookingPetTaxi: return 'Pet Taxi';
            case OpsTowerMenuEnum.BookingTransfers: return 'Transfers';
            case OpsTowerMenuEnum.BookingMoto: return 'Moto';
            case OpsTowerMenuEnum.BookingCars: return 'Cars';
            case OpsTowerMenuEnum.BookingAdmin: return 'Admin';
            case OpsTowerMenuEnum.ConnexRouteConfiguration: return 'Route Configuration';
            case OpsTowerMenuEnum.ConnexBookings: return 'Bookings';
            default: return '';
        }
    }

    protected readonly RiderVehicleTypeEnum = RiderVehicleTypeEnum;
}
